import {Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {DateTime} from "luxon";
import * as AOS from 'aos';

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrl: './website.component.scss'
})
export class WebsiteComponent {
  @ViewChild('navbar') navbar!: ElementRef;
  isTopBarShow: boolean = true;
  private ticking = false;
  isNavbarCollapsed = true;
  public currentYear: string = DateTime.now().toFormat('y');


  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.isTopBarShow = window.scrollY <= 10;
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  ngOnInit() {
    AOS.init({
      duration: 1000,  // Optional: override duration globally
      once: true       // Optional: animate only once
    });
  }

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }
}
